import { render, staticRenderFns } from "./reportList.vue?vue&type=template&id=2d310d62&scoped=true&"
import script from "./reportList.vue?vue&type=script&lang=ts&"
export * from "./reportList.vue?vue&type=script&lang=ts&"
import style0 from "./reportList.vue?vue&type=style&index=0&id=2d310d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d310d62",
  null
  
)

export default component.exports